<template>
  <modal name="modal-about" :width="450">
    <p slot="header">
      {{ $t('About') }}
    </p>
    <slot></slot>
  </modal>
</template>
<script>

import Modal from 'theme/components/core/Modal'

export default {

  components: {
    Modal
  },
    methods: {
        close () {
            this.$bus.$emit('modal-hide', 'modal-about')
        }
    }
}
</script>
